import { UserServiceStorageConfig } from '../../models';

export const DEFAULT_USER_SERVICE_STORAGE_CONFIG: UserServiceStorageConfig = {
  userId: {
    key: 'user-id',
    cookie: 'ebx-user-id',
    ttl: 365 * 24 * 60 * 60 * 1000
  },
  sessionId: {
    key: 'session-id',
    cookie: 'ebx-session-id',
    ttl: 30 * 60 * 1000
  },
  userType: {
    key: 'user-type',
    cookie: 'ebx-user-type',
    ttl: 30 * 60 * 1000
  }
};
